import useCheckPC from "@repo/hooks/utils/useCheckPC";
import _uniqueId from "lodash/uniqueId";
import React from "react";
import { matchPath } from "react-router-dom";

import Button from "@components/atoms/Button";
import Icon from "@components/atoms/Icon";
import MenuItem from "@components/molecules/Menu/MenuItem";
import MenuList from "@components/molecules/Menu/MenuList";

import useLayout from "@hooks/reducerHooks/useLayout";
import useUser from "@hooks/reducerHooks/useUser";

import { MENUS } from "@const/constants";
import { IconName } from "@const/enum";
import { URLS } from "@const/urls";

function LeftMenu() {
  const { isPC } = useCheckPC();
  const { isHeaderOpen, closeHeader, openHeader, openSearch } = useLayout();
  const { accessToken } = useUser();

  const currentPathname = location.pathname;

  const showStoreNav = () => {
    !isHeaderOpen && openHeader();
  };

  const hideStoreNav = () => {
    Boolean(isHeaderOpen) && closeHeader();
  };

  const MENU_ACTIVE: Record<string, boolean> = {
    Shop: Boolean(matchPath(URLS.COLLECTIONS_DETAIL, currentPathname)),
    Membership: Boolean(matchPath(URLS.MEMBERSHIP_PROGRAM, currentPathname)),
    Features: Boolean(matchPath(URLS.FEATURES, currentPathname) || matchPath(URLS.FEATURES_DETAIL, currentPathname)),
    Launches: Boolean(matchPath(URLS.DRAW, currentPathname) || matchPath(URLS.DRAW_DETAIL, currentPathname)),
  };

  return isPC ? (
    <MenuList>
      {accessToken
        ? MENUS.map((menu) =>
            menu.name === "Shop" ? (
              <MenuItem
                className="pr-2.5"
                goToUrl={menu.url}
                key={`left-menu-${menu.name}-${_uniqueId()}`}
                name={menu.name}
                onMouseEnter={showStoreNav}
                showIcon={MENU_ACTIVE[menu.name] || isHeaderOpen}
                type="link"
              />
            ) : (
              <MenuItem
                className="px-2.5"
                goToUrl={menu.url}
                key={`left-menu-${menu.name}-${_uniqueId()}`}
                name={menu.name}
                onMouseEnter={hideStoreNav}
                showIcon={MENU_ACTIVE[menu.name]}
                type="link"
              />
            ),
          )
        : null}
    </MenuList>
  ) : (
    <MenuList className="gap-4">
      {accessToken ? (
        <>
          <li>
            <Button onClick={isHeaderOpen ? hideStoreNav : showStoreNav} variant="icon">
              <Icon
                alt="메뉴"
                height="24px"
                name={isHeaderOpen ? IconName.Close_700 : IconName.Menu_700}
                width="24px"
              />
            </Button>
          </li>
          {!isHeaderOpen && (
            <li>
              <Button onClick={openSearch} variant="icon">
                <Icon alt="검색" height="24px" name={IconName.Search_700} width="24px" />
              </Button>
            </li>
          )}
        </>
      ) : null}
    </MenuList>
  );
}

export default LeftMenu;
